export type HomeTileType = 'CATEGORY' | 'FILTERS' | 'FLAGS' | 'CUSTOM_COLLECTION';

export const HomeTileType = {
    CATEGORY: 'CATEGORY' as const,
    FILTERS: 'FILTERS' as const,
    FLAGS: 'FLAGS' as const,
    CUSTOM_COLLECTION: 'CUSTOM_COLLECTION' as const,
} as const;

export interface HomeTile {
    id: number;
    type: HomeTileType;
    name: string;
    path: string;
    img?: string;
    order: number;
    createdAt: string;
    updatedAt: string;
}

export interface CreateHomeTileDto {
    type: HomeTileType;
    name: string;
    path: string;
    img?: string;
    order?: number;
}

export interface UpdateHomeTileDto {
    name?: string;
    img?: string;
    shouldDeleteImage?: boolean;
}

